import React from "react";
import { ShoppingOutlined } from "@ant-design/icons";
import { HomePhoneProduct } from "../../../../../types/homePhone";

interface ProductThumbProps {
  product: HomePhoneProduct;
}

const ProductThumb: React.FC<ProductThumbProps> = ({ product }) => (
  <div className="or-product-thumb">
    {product.imageUrl ? (
      <img src={product.imageUrl} alt={product.name} />
    ) : (
      <ShoppingOutlined aria-hidden="true" />
    )}
  </div>
);

export default ProductThumb;
